import { getLocalStorageLanguage } from 'commons';
import { LANGUAGE_MAP, SystemLanguageType } from 'constant/language';

const RAW_ORDER_TYPE_MAP = {
  NORMAL: 0,
  TIME_SALE: 1,
  DEPOSIT: 2,
  GUEST: 3,
} as const;

type OrderType = (typeof RAW_ORDER_TYPE_MAP)[keyof typeof RAW_ORDER_TYPE_MAP];

export type OrderTypeOption = {
  value: OrderType;
  label: string;
};

const isValidOrderType = (orderType: number): orderType is OrderType => {
  return Object.values(RAW_ORDER_TYPE_MAP).includes(orderType as OrderType);
};

type OrderTypeConfig = {
  label: Record<SystemLanguageType, string>;
};

const RAW_ORDER_TYPE_CONFIG_MAP: Record<OrderType, OrderTypeConfig> = {
  [RAW_ORDER_TYPE_MAP.NORMAL]: {
    label: {
      [LANGUAGE_MAP.EN]: 'Normal',
      [LANGUAGE_MAP.JA]: '正常注文',
      [LANGUAGE_MAP.ZH_CN]: '正常订单',
    },
  },
  [RAW_ORDER_TYPE_MAP.TIME_SALE]: {
    label: {
      [LANGUAGE_MAP.EN]: 'TimeSale',
      [LANGUAGE_MAP.JA]: 'タイムセールオーダー',
      [LANGUAGE_MAP.ZH_CN]: '秒杀订单',
    },
  },
  [RAW_ORDER_TYPE_MAP.DEPOSIT]: {
    label: {
      [LANGUAGE_MAP.EN]: 'Deposit',
      [LANGUAGE_MAP.JA]: '内金注文',
      [LANGUAGE_MAP.ZH_CN]: '订金订单',
    },
  },
  [RAW_ORDER_TYPE_MAP.GUEST]: {
    label: {
      [LANGUAGE_MAP.EN]: 'Guest',
      [LANGUAGE_MAP.JA]: 'ゲストオーダー',
      [LANGUAGE_MAP.ZH_CN]: 'Guest订单',
    },
  },
} as const;

export const ORDER_TYPE_MAP = new Proxy(RAW_ORDER_TYPE_MAP, {
  ownKeys() {
    throw new Error('禁止遍历 ORDER_TYPE_MAP');
  },
});

export const ORDER_TYPE_CONFIG_MAP = new Proxy(RAW_ORDER_TYPE_CONFIG_MAP, {
  ownKeys() {
    throw new Error('禁止遍历 ORDER_TYPE_CONFIG_MAP');
  },
});

export const getOrderTypeConfig = (orderType: number) => {
  if (!isValidOrderType(orderType)) {
    throw new Error(`Invalid order type: ${orderType}`);
  }

  return ORDER_TYPE_CONFIG_MAP[orderType];
};

export const getOrderTypeOptions = (
  language: SystemLanguageType = getLocalStorageLanguage(),
): OrderTypeOption[] =>
  Object.values(RAW_ORDER_TYPE_MAP).map((value) => ({
    value,
    label: RAW_ORDER_TYPE_CONFIG_MAP[value].label[language],
  }));
